export default __webpack_public_path__ + "static/media/content_02.77667cc1.jpg";